import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import { Box, VStack, Alert, AlertIcon, Center, Spinner } from '@chakra-ui/react';
import BillingInformation from '../BillingInformation';
import TodaysCharges from '../TodaysCharges';
import PaymentDetails from '../PaymentDetails';
import { sizes } from '../../theme';

import useCostData from '../../hooks/UseCostData';
import UnitDetailContent from '../UnitDetailsContent';
import Terms from '../Terms';
import { isValidCard } from '../../modules/cardUtils';
import useUnitData from '../../hooks/UseUnitData';
import { SET_IS_LOADING } from '../MoveIn/reducer';

const propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
    }),
  ),
  closeTAndCModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  showTAndCModal: PropTypes.bool.isRequired,
};

const defaultProps = {
  errors: [],
};

const Step4 = ({ errors, showTAndCModal, closeTAndCModal, onSubmit, step, dispatch }) => {
  const { ccNumber, dcNumber, paymentType } = useWatch();
  const { unitInfo, setUnitInfo, isLoading } = useCostData();
  const { data: { facility: { cardsAccepted } } } = useUnitData();
  let cardNumber;
  if (paymentType === 'credit') {
    cardNumber = ccNumber;
  } else if (paymentType === 'debit') {
    cardNumber = dcNumber;
  } else if (paymentType === 'ach') {
    cardNumber = '';
  }
  // const provider = alias.split(':')[2];

  // eslint-disable-next-line max-len
  const isCardValid = useMemo(() => isValidCard(cardNumber, cardsAccepted), [cardNumber, cardsAccepted]);

  useEffect(() => {
    // if (provider === 'se') {
    if (paymentType === 'credit' || paymentType === 'debit') {
      if (cardNumber && isCardValid) {
        // Add cardNumber to unitInfo only if it is valid
        setUnitInfo({ ...unitInfo, cardNumber });
      } else if (unitInfo && cardNumber) {
        // Remove cardNumber from unitInfo only if it exists
        const { cardNumber: _, ...restUnitInfo } = unitInfo;
        setUnitInfo(restUnitInfo);
      }
    } else if (paymentType === 'ach') {
      if (unitInfo) {
        const { cardNumber: _, ...restUnitInfo } = unitInfo;
        setUnitInfo(restUnitInfo);
      }
    }
    // }
  }, [isCardValid]);

  const methods = useForm({});

  useEffect(() => {
    if (isLoading) {
      dispatch({ type: SET_IS_LOADING, payload: { loading: true, errors } });
    } else {
      dispatch({ type: SET_IS_LOADING, payload: { loading: false, errors } });
    }
  }, [isLoading, dispatch]);

  return (
    <>
      {/* Error Handling Section */}
      <VStack spacing={4} marginBottom={sizes._16px}>
        {errors.map((error, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Alert status="error" key={index}>
            <AlertIcon />
            {error}
          </Alert>
        ))}
      </VStack>

      <PaymentDetails step={step} />
      <Box
        borderBottom="4px solid"
        borderColor="gray.lightBorder"
        marginBottom={sizes._16px}
      />
      <BillingInformation />
      <UnitDetailContent showOn="all" />
      {isLoading ? (
        <Box bgColor="gray.lightBorder" opacity="0.5" position="relative">
          <Center position="absolute" w="100%" h="100%">
            <Spinner size="xl" />
          </Center>
          <TodaysCharges />
        </Box>
      ) : (
        <TodaysCharges />
      )}
      <Terms
        isOpen={showTAndCModal}
        onClose={closeTAndCModal}
        onSubmit={methods.handleSubmit(onSubmit)}
      />
    </>
  );
};

Step4.defaultProps = defaultProps;
Step4.propTypes = propTypes;

export default Step4;
